import { SxProps } from "@mui/material";

export const sxValidationMessage: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#D84141',
  fontSize: 12
}

export const sxLabel: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 600,
}

export const sxOutlinedInputPasswordChange: SxProps = {
  minWidth: '350px',
  '@media (max-width: 768px)': {
    minWidth: 'unset'
  }
}